import { fullJitter } from "./full/full.jitter";
import { noJitter } from "./no/no.jitter";
export function JitterFactory(options) {
    switch (options.jitter) {
        case "full":
            return fullJitter;
        case "none":
        default:
            return noJitter;
    }
}
